import type { CSSProperties, HTMLAttributes, ReactNode } from 'react';
import styles from './Icon.module.css';

export enum IconSize {
    TINY = '12px',
    EXTRA_SMALL = '16px',
    SMALL = '24px',
    STANDARD = '32px',
    LARGE = '48px',
    TEXT = '1em',
}

/**
 * An Icon container that can be initialized with any SVG component.
 */
export const Icon = ({ use, size, className, style, ...rest }: IIconProps) => {
    const classes = size ? `${styles.icon} ${styles.sized}` : styles.icon;
    const mergedStyle = size ? ({ ...style, '--icon-size': size } as CSSProperties) : style;
    return (
        <span className={className ? `${classes} ${className}` : classes} style={mergedStyle} {...rest}>
            {use}
        </span>
    );
};

export interface IIconProps extends HTMLAttributes<HTMLSpanElement> {
    /** An imported react element to use as the icon */
    use: ReactNode;
    /** A predefined size. If not set, the icon will fill the size of the container */
    size?: IconSize;
}
